import { render, staticRenderFns } from "./cefloreco-side-by-side.vue?vue&type=template&id=f8678ebc&scoped=true&"
import script from "./cefloreco-side-by-side.vue?vue&type=script&lang=js&"
export * from "./cefloreco-side-by-side.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-side-by-side.vue?vue&type=style&index=0&id=f8678ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8678ebc",
  null
  
)

export default component.exports